import React from 'react'
import styled from '@emotion/styled'
import { Icon } from '@mobi/component-library/Assets/Icon'
import { colors, font, radius, spacing } from '@mobi/component-library/Foundations'

export const CrossIcon = () => <Icon name='SolidXCircle' size={spacing.md} />

export const List = styled.dl({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  margin: 0,
})

export const ListItem = styled.dd({
  display: 'flex',
  alignItems: 'center',
  gap: spacing.smx1,
  marginInlineStart: 0,

  '& > svg': {
    paddingInlineEnd: '0.5rem',
    '@supports not (padding-inline: 0)': {
      paddingRight: '0.5rem',
    },
  },
  '@supports not (margin-inline: 0)': {
    marginLeft: 0,
  },
})

export const AccountNumberDisplay = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: `${spacing.bigx2} 0`,
  '& > b': {
    color: colors.black,
    ...font.size.xl4,
    fontWeight: font.weight.semibold,
  },
  border: `0.1rem solid ${colors.neutral[300]}`,
  borderRadius: radius.lgx1,
})
